var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.user.firstName)+" ")]},{"user":_vm.user}),_vm._t("test",function(){return [_vm._v(" "+_vm._s(_vm.user.lastName)+" ")]},{"user":_vm.user})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }